import { Divider } from 'antd';
import moment from 'moment';
import React from 'react';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { DataDetailProperty } from '../models/Model_CU-030-01';

interface props {
    data: DataDetailProperty;
}

export const Detail = ({ data }: props) => {
    return (
        <React.Fragment>
            <div className="title-detail">{data.propertyName ?? COMMON.EMPTY}</div>
            <Divider style={{ backgroundColor: '#fff' }} />
            <div className="title-2" style={{ marginTop: 12, marginBottom: 12 }}>
                物件概要
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">所在地</label>
                <p className="content">{data.residence ?? '-'}</p>
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">交通</label>
                <p className="content">
                    {!data?.stationName && !data?.lineName && !data?.footMin
                        ? COMMON.EMPTY
                        : `${data?.lineName ?? ''}${data?.stationName ? data?.stationName + '駅' : ''} 徒歩${
                              data?.footMin ?? ''
                          }分`}
                </p>
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">建物階数</label>
                {/* NOTE: 'floors'は文字列で「階」を含む */}
                <p className="content">{data.floors ? data.floors : COMMON.EMPTY}</p>
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">築年月</label>
                <p className="content">
                    {moment(data.builtAt, true).isValid()
                        ? moment(data.builtAt).format(DATE_FORMAT.FORMAT3)
                        : COMMON.EMPTY}
                </p>
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">構造</label>
                <p className="content">{data.structure ?? COMMON.EMPTY}</p>
            </div>
            <div style={{ marginTop: 16 }}>
                <label className="label">総戸数</label>
                <p className="content">{data.numOfUnit ? `${data.numOfUnit}戸` : COMMON.EMPTY}</p>
            </div>
        </React.Fragment>
    );
};
